import {
  InputGroup
} from "./chunk-6OJINZ37.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/form/select/select.tsx
import { forwardRef } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { jsx } from "react/jsx-runtime";
var Select = forwardRef(function Select2(_a, ref) {
  var _b = _a, { className, size, errorMessage, labelProps, label, id, style, disabled, children } = _b, rest = __objRest(_b, ["className", "size", "errorMessage", "labelProps", "label", "id", "style", "disabled", "children"]);
  return /* @__PURE__ */ jsx(
    InputGroup,
    {
      className: clsx("hds-select", className),
      disabled,
      errorMessage,
      id,
      label,
      labelProps,
      style,
      size,
      children: /* @__PURE__ */ jsx("select", __spreadProps(__spreadValues({}, rest), { disabled, ref, children }))
    }
  );
});
Select.displayName = "Select";

export {
  Select
};
//# sourceMappingURL=chunk-NBEGX26X.mjs.map